import { render, staticRenderFns } from "./WelcomeTwism.vue?vue&type=template&id=2ab9e0c9&scoped=true&"
import script from "./WelcomeTwism.vue?vue&type=script&lang=ts&"
export * from "./WelcomeTwism.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeTwism.vue?vue&type=style&index=0&id=2ab9e0c9&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab9e0c9",
  null
  
)

export default component.exports